/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
/*
  Module that encapsulates the age verification input logic.
 */
angular.module('bulbApp.ageVerificationModule', ['angular-flatpickr', 'restangular', 'bulbApp.configModule']);
